import ApplicationController from './application_controller'

export default class extends ApplicationController {
static targets = ['countForm', 'purchasePriceInput', 'currencyInput', 'showHistoryLink']

  addHwPartCount(event) {
    event.preventDefault();
    this.stimulate('StockReflex#add_hw_part_count', event.target).then(() => {
      const hwPartCount = event.target.parentElement.parentElement.querySelector('.hw-part-count')
      const countInput = event.target.querySelector('.count-input')

      hwPartCount.innerHTML = parseFloat(hwPartCount.innerHTML) + parseFloat(countInput.value)
      countInput.value = 0
    })
  }

  addPurchasePrice(event) {
    event.preventDefault();
    let unitPrice = event.currentTarget.parentElement.parentElement.querySelector('#unit_price_unit_price').value;
    let currency = event.currentTarget.parentElement.parentElement.querySelector('#currency_currency').value;
    this.stimulate('StockReflex#add_unit_price', event.target, unitPrice, currency).then(() => {
      hwPartCount.innerHTML = parseFloat(hwPartCount.innerHTML) + parseFloat(countInput.value)
      countInput.value = 0
    })
  }

  deleteHwPart(event) {
    event.preventDefault()
    if (!confirm(event.target.dataset.confirmMsg)) {
      return
    }
    this.stimulate('StockReflex#delete_hw_part', event.target, event.target.dataset.hwPartId).then(() => {
      const rowTodelete = event.target.closest('tr')
      rowTodelete.remove()
    });
  }
}
